import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { LocationData } from 'src/shared/LocationData.types';

import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C25LocationInfoProps = RenderingProps<C25LocationInfoFields, C25LocationInfoParams> & {
  googleMapsApiKey?: string;
};

export type C25LocationInfoFields = {
  Location?: LocationData & { DetailPageLink?: LinkField };
};

export type C25LocationInfoParams = {
  HideMap?: string;
  ShowHoursOfOperation?: string;
  ShowServicesAvailable?: string;
} & DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;
